import React from 'react';
import { useNavigate } from 'react-router-dom';
import './MoreTasks.css';

function MainTaskButton({ currentTopic, course_name }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (currentTopic) {
      navigate(`/practice?topic=${encodeURIComponent(currentTopic)}&course_name=${encodeURIComponent(course_name)}`);
    } else {
      alert('No topic selected!');
    }
  };

  return (
    <div className="more-task-menu">
        <button className="more-task-button" onClick={handleClick}>
        Хочу еще задач
        </button>
    </div>
  );
}

export default MainTaskButton;
